export default __webpack_public_path__ + "static/media/sticker-cc.dab23246.png";